import { Component, DestroyRef, inject, input, Input, OnInit } from '@angular/core';
import { AbstractControl, FormGroupDirective, ValidationErrors } from '@angular/forms';
import { BehaviorSubject, merge } from 'rxjs';
import { FORM_ERRORS, formErrorMessages } from '../form-errors';
import { AsyncPipe } from '@angular/common';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';

@Component({
  selector: 'app-input-error',
  standalone: true,
  imports: [AsyncPipe],
  templateUrl: './input-error.component.html',
  styleUrl: './input-error.component.scss',
  host: {
    class: 'validation-error',
  },
})
export class InputErrorComponent implements OnInit {
  private formGroupDirective = inject(FormGroupDirective);
  private errors = inject(FORM_ERRORS);
  private destroyRef = inject(DestroyRef);

  group = input<AbstractControl | null>();
  @Input() controlName!: string;
  @Input() customErrors?: ValidationErrors;
  message$ = new BehaviorSubject<string>('');

  ngOnInit(): void {
    const formGroup = this.group() ?? this.formGroupDirective.control;
    if (formGroup) {
      let control = null;
      if (this.controlName) {
        control = formGroup.get(this.controlName);
      } else {
        control = formGroup;
      }

      if (control) {
        this.initErrors(control);

        merge(control.valueChanges, control.statusChanges)
          .pipe(takeUntilDestroyed(this.destroyRef))
          .subscribe(() => {
            this.initErrors(control);
          });
      }
    }
  }

  private initErrors(control: AbstractControl) {
    const controlErrors = control.errors;

    if (controlErrors) {
      const firstKey = Object.keys(controlErrors)[0];
      const getError = this.errors[firstKey as keyof typeof formErrorMessages];
      // Get message from the configuration
      const text = this.customErrors?.[firstKey] || getError?.(controlErrors[firstKey]);
      // Set the error based on the configuration
      this.setError(text);
    } else {
      this.setError('');
    }
  }

  setError(text: string) {
    this.message$.next(text);
  }
}
